import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { RouterState, RouteState } from './types'
import { RootState } from '@/store/types'

export const state: RouterState = {
  from: {} as RouteState,
  to: {} as RouteState,
}

const namespaced = true

export const router: Module<RouterState, RootState> = {
  namespaced,
  mutations,
  actions,
  getters,
  state,
}
